<template>
  <div class="dishes-container">
    <van-tree-select :height="bodyHeight" @click-nav="fetchDishes" :items="categories" :main-active-index.sync="active">
      <template #content>
        <van-row>
          <van-col span="12" v-for="(item, index) in items" :key="index">
                  <div class="item-dishes" @click="detail(index)">
                      <div class="box-image">
                          <van-image fit="cover" :src="item.image" />
                       </div>
                      <div class="info"> </div>
                      <div class="info name"><span v-if="item.code">{{item.code}}.</span> {{item.name.toUpperCase()}}</div>
                      <div class="info price">
                        <span v-if="item.price > 0">€{{item.price}}</span>
                      </div>
                  </div>
         </van-col>
        </van-row>
      </template>
    </van-tree-select>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div @click="show = false" class="closeButton">X</div>
          <van-image width="100%" height="15rem" fit="cover" :src="details.image" />
          <div class="details-info">
            <div class="details-content">
              <div class="details-title">{{details.name}}</div>
              <div class="details-price"><span v-if="details.price > 0">€{{details.price}}</span></div>
              <div class="clearfix"></div>
              <div class="details-describe" v-if="details.describe">
                <hr />
                <strong>Ingredienti:</strong>
                <br>
                <span v-html="details.describe"></span>
              </div>
              
              <div class="details-describe" v-if="details.note">
                <hr />
                <strong>Allergeni / Nota:</strong><br>
                <span v-html="details.note"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
     <div v-if="infoVisible" class="floatButton istruzione" @click="conditionNotes">info</div>
    <div class="floatButton" @click="backToHome"><van-icon name="arrow-left" /></div>
    
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  data() {
    return {
      show: false,
      active: 0,
      categories: [],
      items: [],
      details: {},
      conditionNote: null,
      infoVisible: false
    };
  },
  computed: {
    bodyHeight: function() {
      return document.body.clientHeight;
    },
    
  },
  created(){
    this.fetchCate()
    this.menuFissoNotification()
  },
  methods:{
    fetchCate() {
      this.axios({
        url: "https://zikiya.cooltechw.com/api/dishes/categorie?type="+this.$route.params.type+"&lang="+this.$route.params.lang,
        method: "get"
      }).then(response =>{
        const data = response.data.data
        const cat = data.categories
        const item = data.item
        
        
        for(var i = 0; i < cat.length; i++){
            this.categories.push({'text': cat[i].name.toUpperCase(), 'id': cat[i].id})       
        }
         this.items = item
         this.infoVisible = this.$route.params.type == 3 ? true : false
      })
    },
    fetchDishes(index){
      this.axios({
        url: "https://zikiya.cooltechw.com/api/dishes/index?type=1&lang="+this.$route.params.lang +"&category="+ this.categories[index].id,
        method: "get"
      }).then(response =>{
        this.items = response.data.data
      })
      
    },
    detail(index){
      
      this.details = this.items[index]
      this.show = true
    },
    backToHome(){
      this.$router.push({
        path: "/fushion/"+ this.$route.params.lang
      })
    },
    conditionNotes(){
       localStorage.setItem('conditionNote', 2)
       this.menuFissoNotification()
    },
    menuFissoNotification(){

      if(this.$route.params.type == 3){
        if(localStorage.getItem('conditionNote') != 1){
          if(this.$route.params.lang == 'en'){
            this.conditionNote = 'Dear customers, <br />welcome at ZIKIYA Restaurant.<br />'+
                                'For lunch we propose you the menu below.<br />'+
                                'Starter, first course, second course<br />'+
                                'beverages not included<br />'
          }else{
            this.conditionNote = 'Gentili clienti,<br /> benvenuti al Ristorante ZIKIYA<br />'+
                                  'Per pranzo vi proponiamo<br />'+
                                  'un antipasto a scelta,<br />'+
                                  'un primo piatto a scelta,<br />'+
                                  'un secondo piatto a scelta<br />'+
                                  'Bevande escluse' 


          }
            Dialog.alert({
              title: 'MENU PRANZO 15.00 EURO',
              message: this.conditionNote,
              confirmButtonText: 'OK'
              }).then(() => {
                localStorage.setItem('conditionNote', 1)
              });
        }
      
    }

    }
  }
}
</script>
<style>
.van-dialog__message{
  font-size: 1.2rem;
  font-family: Bebas;
}
.floatButton{
  position: absolute;
  bottom: 2rem;
  right: 1rem;
  padding: 15px;
  width: 1.2em;
  height: 1.2em;
  line-height: 1.6em;
  border-radius: 50px;
  background: red;
  text-align: center;
  color: #ffffff;
}
.istruzione{
  padding: 15px;
  bottom: 6rem;
  right: 1rem;
  width: 1.5em;
  height: 1.5em;
}
.clearfix{
  clear: both;
}
.details-describe p{
  margin: 0;
}
.details-describe{
  margin-top: 30px;
  font-size: 16px;
  font-weight: normal;
}
.details-title{
  float: left;
  font-size: 1.8rem;
      font-weight: 500;
      width: 70%;
}
.details-price{
  color: red;
  width: 30%;
  float: right;
  text-align: right;
}
.details-content{
  widows: 100%;
  font-family: Bebas;
  padding: 15px 10px;
  font-size: 1.7em;
}
.details-info{
  position: absolute;
  top: 45%;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 20px;

}
.wrapper {
    position: relative;
    display: flex;
    height: 100%;
  }
.closeButton{
  z-index: 99999;
  position: absolute;
  width: 2rem;
  height: 2rem;
  text-align: center;
  line-height: 2rem;
  background: #0000006b;
  border-radius: 50px;
  color: #ffffff;
  top: 1em;
  left: 1em;
}
  .block {
    min-width: 100%;
    background-color: #fff;
  }

  .dishes-container .block img{
    height: 20rem;
  }
.dishes-container {
  height: 100%;
}
.van-sidebar .van-tree-select__nav {
  margin-bottom: 50px;
}

.van-tree-select__nav {
  -webkit-box-flex: unset;
  -webkit-flex: unset;
  width: 28%;
  
}

.van-sidebar-item__text {
  width: 100%;
  padding: 5px 0;
  text-align: center;
  font-size: 0.9rem;
  font-family: Bebas;
}

.dishes-container img{
        height: 8rem;
        width: 100%;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
}
.box-image{
  height: 8rem;
  text-align: center;
}
.item-dishes{
        height: 15rem;
        margin: 3px;
        border: 1px solid #e6e6e6;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
}
.item-dishes .info{
  margin: 0 5px;
  font-family: Bebas;
  font-size: 1.02rem;
  font-weight: bold;
  display: block;
}
.name{
  height: 5.0rem;
  overflow:hidden; 
  text-overflow:ellipsis;
  margin-top: 10px;
  border-bottom: 1px solid #e6e6e6;

}
.price{
  color: red;
  text-align: right;

}


@media screen and (min-width: 600px) {
  .box-image {
    height: 12rem;
  }
  .dishes-container img{
        height: 12rem;
        width: 100%;
  }
  .item-dishes{
    height: 20rem;
  }
}
</style>